<script lang="ts">
  import type { Snippet } from 'svelte'
  import type { HTMLButtonAttributes } from 'svelte/elements'

  type Props = HTMLButtonAttributes & {
    children: Snippet
    size?: number
    iconSize?: number
  }

  let {
    children,
    size = 1.5,
    iconSize = 0.875,
    class: className,
    ...rest
  }: Props = $props()
</script>

<button
  style:--button-size="{size}rem"
  style:--icon-size="{iconSize}rem"
  class={['container', className]}
  {...rest}
>
  {@render children?.()}
</button>

<style lang="scss">
  .container {
    background-color: transparent;
    padding: 0;
    border: none;
    outline: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--icon-button-foreground);
    min-height: var(--button-size);
    min-width: var(--button-size);
    width: var(--button-size);
    height: var(--button-size);

    :global(svg) {
      min-height: var(--icon-size);
      min-width: var(--icon-size);
      width: var(--icon-size);
      height: var(--icon-size);
    }

    &:hover:not(:disabled) {
      color: var(--icon-button-hover-foreground);
    }

    &:focus-visible {
      outline: 1px solid var(--stroke);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
</style>
